import { Offer } from '../../../shared/models/offers.model';
import { NmWebElement, NmWebSection } from '../../../shared/models/nm-webs.interfaces';
import { ENmWebElementTypes } from '../../../shared/constants/nm-webs.enums';
import { FeaturedLinks } from '../models/cms.interface';
import { Link } from '../../../shared/models/link.interface';
import { INTERNAL_DOMAINS } from '../constants/cms.constant';
import { ExchangeRate } from '../../../shared/models/flights/flight-search.model';

export function getSectionElementContent(
  section: NmWebSection | undefined,
  type: ENmWebElementTypes
): string {
  return section?.nmWebElements.find((el) => el.nmGenericType.name === type)?.content ?? '';
}

export function enrichFlightOfferWithExchange(offer: Offer, exchangeRate: ExchangeRate): Offer {
  return {
    ...offer,
    currencyExchange: {
      currency: exchangeRate.currencyCode,
      amount: exchangeRate.factor,
    },
  };
}

export function parseCmsSectionToFeaturedLinks(childSection: NmWebSection): FeaturedLinks {
  const mapLinks = (cmsElement: NmWebElement): Link => {
    const { content, redirectUrl } = cmsElement;

    const fullUrl = redirectUrl ?? '';
    const isExternal = isExternalLink(fullUrl);

    return {
      text: content ?? '',
      redirectionUrl: isExternal ? fullUrl : getRelativePath(fullUrl),
      isExternalLink: isExternal,
    };
  };

  return {
    title: childSection.description,
    links: childSection.nmWebElements
      .sort((a, b) => (a.elementOrder ?? 0) - (b.elementOrder ?? 0))
      .map((e) => mapLinks(e)),
  };
}

export function isExternalLink(link: string): boolean {
  if (!link) return false;
  const t = link.trim();

  if (t.startsWith('/') || t.startsWith('#')) return false;

  const isSpecial = /^(mailto:|tel:|sms:|WhatsApp:|javascript:)/i.test(t);
  if (isSpecial) return true;

  try {
    const { hostname } = new URL(t);
    const host = hostname.toLowerCase().replace('www.', '');

    return ![...INTERNAL_DOMAINS].some((domain) => host === domain || host.endsWith('.' + domain));
  } catch {
    return false;
  }
}

export function getRelativePath(fullUrl: string): string {
  if (!fullUrl) return '/';

  try {
    const { pathname, search, hash } = new URL(fullUrl, 'https://www.nmviajes.com');
    return `${pathname}${search}${hash}`;
  } catch {
    return fullUrl;
  }
}
